<template>
    <div class="testimonials">
        <div class="overlay"></div>
        <div :class="sliderKey">
            <div v-for="(testimonial, index) in testimonials" :key="`testiminial-${index}`" class="testimonial container-fluid">
                <p class="content" v-html="testimonial.content"></p>
                <div class="person">
                    <img :src="testimonial.avatar"/>
                    <div class="info">
                        <h4 v-text="testimonial.name"></h4>
                        <div v-text="testimonial.location"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

require('slick-carousel')
import Helpers from '@/mixins/Helpers'

export default {

    mixins:[Helpers],


    data() {
        return {
            testimonials: [
                // Ria Sethi
                {
                    name: 'Ria Sethi',
                    decriptor: 'Ice cream connoisseur',
                    avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/9555/conversions/uploaded_file-jpg-avatar.jpg',
                    location: 'Los Angeles',
                    content: '&ldquo;I feel like I finally have a place I can get access to all the best spots in a city without having to spend hours searching online. The quality is top notch.&rdquo;',
                    verified: false,
                },
                // Michelle Fahlbusch
                {
                    name: 'Michelle Fahlbusch',
                    decriptor: 'Fitness Enthusiast',
                    avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/9005/conversions/uploaded_file-jpg-avatar.jpg',
                    location: 'Denver',
                    content: '&ldquo;This is my secret weapon for finding unique, local spots on all my trips!&rdquo;',
                    verified: false,
                },
                // Jason Oney
                {
                    name: 'Jason Oney',
                    decriptor: 'Wine Enthusiast',
                    avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/7282/conversions/uploaded_file-jpg-avatar.jpg',
                    location: 'Boise',
                    content: '&ldquo;We travel with our pup a lot and am always looking for great pet friendly spots. I love being able to find recs from other pet owners on places they’ve been!&rdquo;',
                    verified: false,
                },
                // Andrew Klinkhammer
                {
                    name: 'Andrew Klinkhammer',
                    decriptor: 'Comedian',
                    avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/7287/conversions/uploaded_file-jpg-avatar.jpg',
                    location: 'Chicago',
                    content: '&ldquo;I feel like I’ve wasted so much time trying to figure out what to do when exploring new cities. Now I just check Well Traveled and boom.&rdquo;',
                    verified: false,
                },
                // Kendra Arenkill
                {
                    name: 'Kendra Arenkill',
                    decriptor: 'Avid Hiker',
                    avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/8776/conversions/uploaded_file-jpg-avatar.jpg',
                    location: 'Chicago',
                    content: '&ldquo;With limited vacation time I’m always trying to maximize my time in a city. Well Traveled helps me find hidden gems in every city.&rdquo;',
                    verified: false,
                },
                // Liz Taistra
                {
                    name: 'Liz Taistra',
                    decriptor: 'Skier',
                    avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/11447/conversions/uploaded_file-jpg-avatar.jpg',
                    location: 'San Francisco',
                    content: '&ldquo;Booking was a seamless experience & the team was fantastic to work with. My boyfriend kept saying, "how did you get all this?” I definitely felt like a VIP.&rdquo;',
                    verified: false,
                },
            ],
            sliderKey: null,
        }
    },

    created(){
        this.sliderKey = `slider-${this._uid}`
    },

    mounted() {
        $('.' + this.sliderKey).slick({
            fade: true,
            prevArrow: '<span class="slick-prev"><svg><use xlink:href="#carousel-arrow-left"></use></svg></span>',
            nextArrow: '<span class="slick-next"><svg><use xlink:href="#carousel-arrow-right"></use></svg></span>',
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 600,
                settings: {
                    dots: false,
                }
            }]
        })
    }
}
</script>
